import { Component, OnInit, Input, AfterViewInit, ViewChild, OnDestroy } from '@angular/core';
import { MatTableDataSource, MatSort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { CoreTask } from 'app/students/core-task';
import { StudentsService } from '../../students.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { SemsoSnackbarService } from 'app/semso-snackbar.service';
import { StateService } from '../../state.service';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';
import { SemsoEncryptionModule } from 'app/encryption/encryption.module';
import { ExplanationService } from '../../examination/explanation.service';
import { environment } from '../../../environments/environment';
import { CoreTaskService } from '../core-task.service';

@Component({
  selector: 'app-keuzedeel',
  templateUrl: './keuzedeel.component.html',
  styleUrls: ['./keuzedeel.component.scss']
})
export class KeuzedeelComponent implements OnInit, AfterViewInit, OnDestroy { 
  private _coreTasks;
  private studentIdEncrypted;
  private creboId;
  private routeSubscription: Subscription;
  private studentSubscription: Subscription;
  private startCoreSubjectErrorSubscription: Subscription;
  private destroy$ = new Subject();

  @ViewChild(MatSort) sort: MatSort;
  private displayedColumns = ['kerntaakCode', 'kerntaakOmschrijving', 'resultaat', 'startButton', 'laatsteWerkproces'];
  public dataSource = new MatTableDataSource();
  public resultaatTitle = 'Resultaat';
  private coreTasksSubscription: Subscription;
  private keuzedelenTasksSubject = new Subject<CoreTask[]>();
  public keuzedelenTasks$ = this.keuzedelenTasksSubject.asObservable();
  
  constructor
    (private breadcrumbService: BreadcrumbService,
      private studentService: StudentsService,
      private route: ActivatedRoute,
      private router: Router,
      private snackbar: SemsoSnackbarService,
      private stateService: StateService,
      private encryption: SemsoEncryptionModule,
      private explanationService: ExplanationService,
    private coreTaskService: CoreTaskService) { }
  ngOnInit() {
    this.route.params
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(params => {
        this.studentIdEncrypted = params['studentIdEncrypted'];
        this.creboId = params['creboId'];
      });

    this.studentService.startCoreSubjectError$
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(data => {
        this.snackbar.error('Fout bij het starten van een nieuwe kerntaak');
      });

    this.dataSource = new MatTableDataSource([]);
    this.route.params
      .takeUntil(this.destroy$)
      .subscribe(params => {
        
        this.coreTasksSubscription = this.coreTaskService
          .getCoreTasksByStudentAndCreboId(params['studentIdEncrypted'], params['creboId'])
          .subscribe(data => {            
            var keuzedelen = data.filter(item => {   
              return item.isKeuzedeel == true;
            });            
            this.dataSource.data = keuzedelen;            
          });        
      });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  startNewCoreTask(coreTaskId: string, creboId: string) {
    var _encrypted = this.studentIdEncrypted;
    var _creboId= this.creboId;
    this.studentService.startCoreTaskByStudentIdAndCoreTaskId(this.studentIdEncrypted, coreTaskId, creboId)
      .takeUntil(this.destroy$)
      .subscribe(data => {
        this.router.navigate(['students', _encrypted, _creboId, 'crebos', 'examination', data, 'data-check'], { queryParamsHandling: 'merge' })
      });
  }

  hervatNewCoreTask(creboKerntaakId: string, coreTaskId: string, creboId: string) {
    var _encrypted = this.studentIdEncrypted;
    var _creboId = this.creboId;
    this.studentService.startCoreTaskByStudentIdAndCoreTaskId(this.studentIdEncrypted, coreTaskId, creboId)
      .takeUntil(this.destroy$)
      .subscribe(data => {
        this.router.navigate(['students', _encrypted, _creboId, 'crebos', 'examination', creboKerntaakId, 'data-check'], { queryParamsHandling: 'merge' })
      });
  }

  openSideNav(coreTaskId: string, pagina: number) {
    this.explanationService.setExplanationSourceUrl(`${environment.api}/kerntaken/${coreTaskId}/pdf/gevuld`)
    this.explanationService.openExplanation(pagina);
  }
}



// WEBPACK FOOTER //
// ./src/app/students/keuzedeel/keuzedeel.component.ts